import { render, staticRenderFns } from "./schoolClassManagement.vue?vue&type=template&id=0fcfa99a&scoped=true&"
import script from "./schoolClassManagement.vue?vue&type=script&lang=js&"
export * from "./schoolClassManagement.vue?vue&type=script&lang=js&"
import style0 from "./schoolClassManagement.vue?vue&type=style&index=0&id=0fcfa99a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcfa99a",
  null
  
)

export default component.exports